import { useState, useCallback } from 'react'

export const useHttp = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const API_URL = 'https://gitlab.com'


  const request = useCallback(async (url, method = 'GET', body = null, headers = {}) => {
    // url = "http://localhost:5003" + url
    setLoading(true)
    try {
      if (body) {
        body = JSON.stringify(body)
        headers['Content-Type'] = 'application/json'
      }


      const response = await fetch(url, { method, body, headers })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка запроса на сервер')
      }

      setLoading(false)

      return data
    } catch (e) {
      setLoading(false)
      setError(e.message)
      throw e
    }
  }, [])







  const gitRequest = useCallback(async (url, method = 'GET', body = null, headers = {}) => {
    url = `${API_URL}${url}`
    setLoading(true)
    try {
      if (body) {
        body = JSON.stringify(body)
        headers['Content-Type'] = 'application/json'
      }

      const response = await fetch(url, {method, body, headers})
      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка запроса на сервер')
      }

      setLoading(false)

      return data
    } catch (e) {
      setLoading(false)
      setError(e.message)
      throw e
    }
  }, [])




  const gitTextRequest = useCallback(async (url, method = 'GET', body = null, headers = {}) => {
    url = `${API_URL}${url}`
    setLoading(true)
    try {
      if (body) {
        body = JSON.stringify(body)
        headers['Content-Type'] = 'application/json'
      }

      const response = await fetch(url, {method, body, headers})
      const data = await response.text()

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка запроса на сервер')
      }

      setLoading(false)

      return data
    } catch (e) {
      setLoading(false)
      setError(e.message)
      throw e
    }
  }, [])




  const fileUpload = useCallback(async (url, method = 'POST', body = null, headers = {}) => {
    setLoading(true)
    try {
      const response = await fetch(url, { method, body, headers })
      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка запроса на сервер')
      }

      setLoading(false)

      return data
    } catch (e) {
      setLoading(false)
      setError(e.message)
      throw e
    }
  }, [])

  const clearError = useCallback(() => setError(null), [])

  return { loading, request, error, clearError, fileUpload, gitRequest, gitTextRequest }
}